import { http } from '@/core/api'
import type {
  PersonalWorkbenchKpiMetrics,
  PersonalWorkbenchTab,
} from '@/features/leads/api/lead-library.api'

export type RecruitmentWorkbenchDashboard = {
  tab_counts: Partial<Record<PersonalWorkbenchTab, number>>
  kpi_metrics: PersonalWorkbenchKpiMetrics
  employment_recall_count?: number
}

export type RecruitmentWorkbenchDashboardParams = {
  /** Bàn làm việc: Chờ FU badge + today's cards only (no full tab / reclaim / supervisor COUNTs). */
  home?: boolean
  assignee_id?: number
  team_id?: number
  only_mine?: boolean
  search?: string
  follow_up_status?: string
  care_status?: string
  priority?: string
  next_follow?: 'today'
  zalo_added?: boolean
  traffic_channel_id?: number
  platform?: string
  traffic_source_id?: number
  ingestion_method?: string
  client_id?: number
  imported_from?: string
  imported_to?: string
  kpi_date_from?: string
  kpi_date_to?: string
  kpi_date_all?: boolean
  work_area?: string
}

export const recruitmentWorkbenchApi = {
  async dashboard(params: RecruitmentWorkbenchDashboardParams = {}) {
    const { data } = await http.get('/recruitment/workbench/dashboard', { params })
    return data as { data: RecruitmentWorkbenchDashboard }
  },
}
